<template>
  <!-- 新增住户 -->
  <div class="addresident">
    <el-dialog
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      title="基本信息"
      :visible.sync="this.vis"
      width="1170px"
      :before-close="handleClose"
    >
      <div class="bodymsg">户基本信息</div>
      <el-form
        :inline="true"
        :model="familyform"
        class="demo-form-inline"
        label-width="100px"
        style="color: #000"
      >
        <el-form-item label="户主姓名">
          <el-input
            v-model="familyform.familyHeadCode"
            placeholder="户主姓名"
          ></el-input>
        </el-form-item>
        <!-- <el-input v-model="familyform.familyMold" value="1"></el-input> -->
        <el-form-item label="性质">
          <el-select v-model="familyform.familyType" placeholder="性质">
            <el-option label="常住" value="0"></el-option>
            <el-option label="出租" value="1"></el-option>
            <el-option label="流动" value="2"></el-option>
            <el-option label="空房" value="3"></el-option>
            <el-option label="境外" value="4"></el-option>
            <el-option label="未落户" value="5"></el-option>
            <!-- <el-option label="民用住户" value="1"></el-option> -->
            <!-- <el-option label="商业住户" value="2"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="门牌号">
          <el-input
            @blur="searchis"
            v-model="familyform.doorCode"
            placeholder="门牌号"
          ></el-input>
        </el-form-item>
        <el-form-item label="户成员数">
          <el-input
            v-model="familyform.familyPersonCount"
            placeholder="户成员数"
          ></el-input>
        </el-form-item>
        <el-form-item label="房屋面积">
          <el-input
            v-model="familyform.familyArea"
            placeholder="房屋面积"
          ></el-input>
        </el-form-item>
        <el-form-item label="楼栋名称">
          <el-input
            v-model="familyform.sectionName"
            placeholder="楼栋名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="房主姓名">
          <el-input
            v-model="familyform.houseOwnerName"
            placeholder="房主姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="房主联系电话">
          <el-input
            v-model="familyform.houseOwnerPhone"
            placeholder="房主联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item class="btnform" style="width: 100%" label>
          <el-button type="primary" @click="resetSubmit1">修改</el-button>
          <el-button type="primary" @click="handleClose">关闭</el-button>
        </el-form-item>
      </el-form>
      <!-- 第二个 -->
      <!-- ? switch two form window -->
      <div
        :class="{ activesiwtch: formSwitch == 3 }"
        class="bodymsg switchpage"
        @click="chickpage(2)"
      >
        人员信息
      </div>
      <!-- 第三个 -->
      <div
        :class="{ activesiwtch: formSwitch == 2 }"
        class="bodymsg switchpage"
        @click="chickpage(3)"
      >
        扩展信息
      </div>
      <el-form
        v-show="this.formSwitch == 2"
        :inline="true"
        :model="userform"
        label-width="100px"
        ref="userform"
        class="demo-form-inline"
      >
        <el-form-item label="姓名">
          <el-input v-model="userform.personName" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input
            v-model="userform.idCode"
            placeholder="身份证号"
            @change="getName(userform.idCode)"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-select v-model="userform.sexType" placeholder="性别">
            <el-option label="男" value="0"></el-option>
            <el-option label="女" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="政治面貌">
          <el-select v-model="userform.partyType" placeholder="政治面貌">
            <el-option label="中共党员" value="0"></el-option>
            <el-option label="共青团员" value="1"></el-option>
            <el-option label="群众" value="2"></el-option>
            <el-option label="其他" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="党派">
          <el-select v-model="userform.party" placeholder="党派">
            <el-option label="无" value></el-option>
            <el-option label="中国国民党革命委员会" value="0"></el-option>
            <el-option label="中国民主同盟" value="1"></el-option>
            <el-option label="中国民主建国会" value="2"></el-option>
            <el-option label="中国民主促进会" value="3"></el-option>
            <el-option label="中国农工民主党" value="4"></el-option>
            <el-option label="中国致公党" value="5"></el-option>
            <el-option label="九三学社" value="6"></el-option>
            <el-option label="台湾民主自治同盟" value="7"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="户籍一致">
          <el-select v-model="userform.isHousehold" placeholder="户籍一致">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文化程度">
          <el-select v-model="userform.personStudy" placeholder="文化程度">
            <el-option label="初中" value="0"></el-option>
            <el-option label="高中" value="1"></el-option>
            <el-option label="职校" value="2"></el-option>
            <el-option label="专科" value="3"></el-option>
            <el-option label="本科" value="4"></el-option>
            <el-option label="研究生" value="5"></el-option>
            <el-option label="博士" value="6"></el-option>
            <el-option label="其他" value="7"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="婚姻状况">
          <el-select v-model="userform.maritalStatus" placeholder="婚姻状况">
            <el-option label="初婚" value="0"></el-option>
            <el-option label="再婚" value="1"></el-option>
            <el-option label="未婚" value="2"></el-option>
            <el-option label="离异" value="3"></el-option>
            <el-option label="丧偶" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input
            v-model="userform.linkPhone"
            placeholder="联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="民族">
          <el-input v-model="userform.nationType" placeholder="民族"></el-input>
        </el-form-item>
        <el-form-item label="户籍地址">
          <el-input
            v-model="userform.originPlace"
            placeholder="户籍地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="出生日期">
          <!-- <el-input
            v-model="userform.birthDay"
            placeholder="出生日期"
          ></el-input>-->
          <el-date-picker
            v-model="userform.birthDay"
            type="date"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="年龄">
          <el-input v-model="userform.personAge" placeholder="年龄"></el-input>
        </el-form-item>
        <el-form-item label="籍贯">
          <el-input
            v-model="userform.nativePlace"
            placeholder="籍贯"
          ></el-input>
        </el-form-item>
        <el-form-item label="工作单位">
          <el-input
            v-model="userform.jobName"
            placeholder="工作单位"
          ></el-input>
        </el-form-item>
        <el-form-item label="与户主关系">
          <el-select v-model="userform.relationship" placeholder="与户主关系">
            <el-option label="本人" value="1001"></el-option>
            <el-option label="夫妻" value="1002"></el-option>
            <el-option label="父亲" value="1003"></el-option>
            <el-option label="母亲" value="1004"></el-option>
            <el-option label="岳父" value="1005"></el-option>
            <el-option label="岳母" value="1006"></el-option>
            <el-option label="长子" value="1007"></el-option>
            <el-option label="次子" value="1008"></el-option>
            <el-option label="长女" value="1009"></el-option>
            <el-option label="次女" value="1010"></el-option>
            <el-option label="其他" value="1011"></el-option>
            <el-option label="儿媳" value="1012"></el-option>
            <el-option label="孙子" value="1013"></el-option>
            <el-option label="孙女" value="1014"></el-option>
            <el-option label="女婿" value="1015"></el-option>
            <el-option label="租户" value="1016"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="两代表一委员">
          <el-select v-model="userform.commissary" placeholder="两代表一委员">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房屋产权到期时间">
          <el-date-picker
            v-model="userform.houseExpirationTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="date"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="上传照片" class="newuploadsBox">
          <!-- <div class="uploads" style="width:0px;height:0px;border:none">
            <input type="file" value="uploading" ref="gird_up" id="file2" @change="uploadConfiggrid"/>
          </div>
          <div class="uploads uploads-files" v-show="userform.personPhoto != ''">
            <img :src="userform.personPhoto" alt="" width="100%" height="100%" />
            <i class="el-icon-error" style="position:absolute;right:-5px;top:-5px;cursor:pointer;" @click.stop="closeIMG()"></i>
          </div>
          <div class="uploads doorphoto" @click="up_click_girdhead" v-show="userform.personPhoto=='' || userform.personPhoto==null">
            <span class="uoloaddoor">上传图片</span>
            <span class="iconfont icon-tianjia1 dooricon"> + </span>
          </div>-->
          <el-upload
            class="avatar-uploader"
            action="http://121.40.26.248:9001/qianmi-wisdom-zhsq-web-api/ypt/controller/uploadVotePic/info/uploadPartyVote"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
          >
            <img
              v-if="userform.personPhoto"
              :src="userform.personPhoto"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item class="btnform" style="width: 100%" label>
          <el-button
            v-show="arorreset == 'add'"
            type="primary"
            @click="onSubmit1"
            >保存</el-button
          >
          <el-button
            v-show="arorreset == 'reset'"
            type="primary"
            @click="onSubmit1"
            >修改</el-button
          >
          <el-button
            v-show="arorreset == 'reset'"
            type="primary"
            @click="onSubmit1('delete')"
            >删除</el-button
          >
          <el-button type="primary" @click="handleClose">关闭</el-button>
        </el-form-item>
      </el-form>

      <el-form
        v-show="this.formSwitch == 3"
        :inline="true"
        :model="userform"
        label-width="100px"
        class="demo-form-inline"
      >
        <el-form-item label="居住性质">
          <!-- <el-input
            v-model="userform.liveType"
            placeholder="居住性质"
          ></el-input>-->
          <el-select v-model="userform.liveType" placeholder="性质">
            <el-option label="常住" value="0"></el-option>
            <el-option label="出租" value="1"></el-option>
            <el-option label="流动" value="2"></el-option>
            <el-option label="空房" value="3"></el-option>
            <el-option label="境外" value="4"></el-option>
            <el-option label="未落户" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="流动人口">
          <el-input
            v-model="userform.floatPerson"
            placeholder="流动人口"
          ></el-input>
        </el-form-item>
        <el-form-item label="低保人员">
          <!-- <el-input
            v-model="userform.guaranteePerson"
            placeholder="低保人员"
          ></el-input>-->
          <el-select v-model="userform.guaranteePerson" placeholder="请选择">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="低保类型">
          <!-- <el-input v-model="userform.guaranteeType" placeholder="请输入"></el-input> -->
          <el-select v-model="userform.guaranteeType" placeholder="请选择">
            <el-option label="A类" value="1"></el-option>
            <el-option label="B类" value="2"></el-option>
            <el-option label="C类" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="低保证号">
          <el-input
            v-model="userform.guaranteeNum"
            placeholder="低保证号"
          ></el-input>
        </el-form-item>
        <el-form-item label="刑满释放">
          <el-select v-model="userform.rele" placeholder="请选择">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="社区矫正">
          <el-select v-model="userform.correct" placeholder="请选择">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="重点青少年">
          <el-select v-model="userform.teenagers" placeholder="请选择">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="吸毒">
          <el-select v-model="userform.drug" placeholder="请选择">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="艾滋病">
          <el-select v-model="userform.adis" placeholder="请选择">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="精神病">
          <!-- <el-input
            v-model="userform.oldPerson"
            placeholder="独居老人"
          ></el-input>-->
          <el-select v-model="userform.spirit" placeholder="请选择">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服刑">
          <!-- <el-input v-model="userform.user" placeholder="三无老人"></el-input> -->
          <el-select v-model="userform.sentence" placeholder="请选择">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="非法组织">
          <!-- <el-input v-model="userform.user" placeholder="三无老人"></el-input> -->
          <el-select v-model="userform.illegal" placeholder="请选择">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上访人员">
          <el-select v-model="userform.petition" placeholder="请选择">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="低保人员">
          <el-select v-model="userform.guaranteePerson" placeholder="请选择">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="空巢老人">
          <!-- <el-input v-model="userform.user" placeholder="残疾类型"></el-input> -->
          <el-select v-model="userform.absentParent" placeholder="请选择">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="留守儿童">
          <!-- <el-input v-model="userform.user" placeholder="残疾类型"></el-input> -->
          <el-select v-model="userform.stayBehind" placeholder="请选择">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="失独人员">
          <!-- <el-input v-model="userform.user" placeholder="残疾类型"></el-input> -->
          <el-select v-model="userform.oldPerson" placeholder="请选择">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="孤寡老人">
          <!-- <el-input v-model="userform.user" placeholder="残疾类型"></el-input> -->
          <el-select v-model="userform.nooldPerson" placeholder="请选择">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="优抚人员">
          <!-- <el-input v-model="userform.user" placeholder="残疾类型"></el-input> -->
          <el-select v-model="userform.helpPerson" placeholder="请选择">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="育龄妇女">
          <!-- <el-input v-model="userform.user" placeholder="残疾类型"></el-input> -->
          <el-select v-model="userform.woman" placeholder="请选择">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="残疾人">
          <!-- <el-input v-model="userform.user" placeholder="残疾类型"></el-input> -->
          <el-select v-model="userform.disabilityPerson" placeholder="请选择">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="残疾证">
          <!-- <el-input v-model="userform.user" placeholder="残疾类型"></el-input> -->
          <el-select v-model="userform.isDisabilityCard" placeholder="请选择">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="残疾人类型">
          <!-- <el-input v-model="userform.user" placeholder="残疾等级"></el-input> -->
          <el-select v-model="userform.disabilityType" placeholder="请选择">
            <el-option label="精神" value="0"></el-option>
            <el-option label="肢体" value="1"></el-option>
            <el-option label="听力" value="2"></el-option>
            <el-option label="言语" value="3"></el-option>
            <el-option label="视力" value="4"></el-option>
            <el-option label="智力" value="5"></el-option>
            <el-option label="多重" value="6"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="残疾等级">
          <!-- <el-input v-model="userform.user" placeholder="残疾等级"></el-input> -->
          <el-select v-model="userform.disabilityLevel" placeholder="请选择">
            <el-option label="一级" value="0"></el-option>
            <el-option label="二级" value="1"></el-option>
            <el-option label="三级" value="2"></el-option>
            <el-option label="四级" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="残疾人证件号">
          <el-input
            v-model="userform.disabilityCard"
            placeholder="残疾人证件号"
          ></el-input>
        </el-form-item>
        <el-form-item label="退役军人">
          <!-- <el-input v-model="userform.retireSoldier" placeholder="退役军人"></el-input> -->
          <el-select v-model="userform.retireSoldier" placeholder="请选择">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退役军人类型">
          <!-- <el-input
            v-model="userform.user"
            placeholder="退役军人类型"
          ></el-input>-->
          <el-select v-model="userform.soldierType" placeholder="请选择">
            <el-option label="军转干部" value="0"></el-option>
            <el-option label="退役士兵" value="1"></el-option>
            <el-option label="优抚对象" value="2"></el-option>
            <el-option label="现役军人家属" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退役军人证件号">
          <el-input
            v-model="userform.soldierNum"
            placeholder="退役军人证件号"
          ></el-input>
        </el-form-item>
        <el-form-item label="特长">
          <el-input v-model="userform.hobby" placeholder="特长"></el-input>
        </el-form-item>
        <el-form-item label="志愿者">
          <!-- <el-input v-model="userform.volunteer" placeholder="志愿者"></el-input> -->
          <el-select v-model="userform.volunteer" placeholder="志愿者">
            <el-option label="是" value="0"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="userform.remark" placeholder="备注"></el-input>
        </el-form-item>

        <el-form-item class="btnform" style="width: 100%" label>
          <el-button
            v-show="arorreset == 'add'"
            type="primary"
            @click="onSubmit1"
            >保存</el-button
          >
          <el-button
            v-show="arorreset == 'reset'"
            type="primary"
            @click="onSubmit1"
            >修改</el-button
          >
          <el-button type="primary" @click="handleClose">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["vis"],
  data() {
    return {
      // ? door upload photo and file
      girduploadfilephoto: "",
      girduploadfile: "", // ? door's  e.target.files[0]
      formSwitch: 2,
      familyform: {},
      userform: {
        // sexType: "",
        // personAge: "",
        // birthDay: "",
        // personStudy: "6",
        // personPhoto: ""
      },
      loading: false,
      sectionMapId: "",
      olddoorCode: "",
      filesList: [], //照片集合
      // 判断用户点击的事修改还是新增
      arorreset: "",
      baseFormRules: {
        idCode: [
          {
            required: true,
            message: "身份证号不能为空",
            trigger: "blur",
          },
          { validator: this.validID, trigger: "blur" },
        ],
      },
    }
  },
  // created() {
  //   // console.log(this.$attrs);
  // },
  mounted() {
    // 监听添加,修改人员的点击事件
    this.$Bus.$on("adduser", (userform, familyform, ar) => {
      this.getdata(userform, familyform, ar)
    })
  },
  beforeDestroy() {
    // 页面销毁前 取消所有事件总线的监听
    this.$Bus.$off()
  },
  computed: {
    channel() {
      return this.familyform.doorCode
    },
    // channel2() {
    //   return this.familyform.doorCodeHide;
    // }
  },
  watch: {
    channel(newValue, oldValue) {
      // this.oldmenpai = oldValue;
      // 　　　　console.log('new: %s, old: %s', newval, oldVal)
      this.familyform.familyCode =
        this.familyform.sectionMapId +
        "part_" +
        this.familyform.cellNum +
        "_" +
        newValue //这里面可以执行一旦监听的值发生变化你想做的操作
      this.familyform.doorCodeHide =
        "part_" + this.familyform.cellNum + "_" + newValue
    },
  },
  methods: {
    getName(iden) {
      console.log(iden)
      let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      if (reg.test(iden)) {
        let val = iden.length
        let sex = null
        let birth = null
        let myDate = new Date()
        let month = myDate.getMonth() + 1
        let day = myDate.getDate()
        let age = 0

        if (val === 18) {
          age = myDate.getFullYear() - iden.substring(6, 10) - 1
          sex = iden.substring(16, 17)
          birth =
            iden.substring(6, 10) +
            "-" +
            iden.substring(10, 12) +
            "-" +
            iden.substring(12, 14)
          if (
            iden.substring(10, 12) < month ||
            (iden.substring(10, 12) == month && iden.substring(12, 14) <= day)
          ) {
            age++
          }
        }
        if (val === 15) {
          age = myDate.getFullYear() - iden.substring(6, 8) - 1901
          sex = iden.substring(13, 14)
          birth =
            "19" +
            iden.substring(6, 8) +
            "-" +
            iden.substring(8, 10) +
            "-" +
            iden.substring(10, 12)
          if (
            iden.substring(8, 10) < month ||
            (iden.substring(8, 10) == month && iden.substring(10, 12) <= day)
          ) {
            age++
          }
        }

        if (sex % 2 === 0) {
          sex = "1"
        } else {
          sex = "0"
        }

        this.userform.sexType = sex
        this.userform.personAge = age
        this.userform.birthDay = birth
        //console.log(this.userform.sexType);
        this.$forceUpdate()
      } else if (iden == "") {
        //console.log("wwd")
        this.userform.sexType = ""
        this.userform.personAge = ""
        this.userform.birthDay = ""
        this.$forceUpdate()
      } else {
        this.$message.warning("身份证号码不正确")
        return false
      }
    },

    // ? upload door photo
    uploadConfiggrid(e) {
      console.log(e.target.files)
      let _this = this
      let files = e.target.files[0]
      this.girduploadfile = files
      if (!e || !window.FileReader) return // 看支持不支持FileReader
      let reader = new FileReader()
      reader.readAsDataURL(files) // 这里是最关键的一步，转换就在这里
      reader.onloadend = function () {
        _this.girduploadfilephoto = this.result
        _this.userform.personPhoto = this.result
        // _this.filesList.push({src:reader.result});
        console.log(_this.filesList)
      }
    },
    // box点击时,触发input的点击事件
    up_click_girdhead() {
      this.$refs["gird_up"].click()
    },
    closeIMG() {
      this.userform.personPhoto = ""
    },
    getdata(userform, familyform, ar) {
      this.familyform = familyform
      this.userform = userform
      this.girduploadfilephoto = this.userform.personPhoto
      this.userform.familyCode = this.familyform.familyCode
      this.olddoorCode = this.familyform.doorCode

      console.log(ar)
      this.arorreset = ar
      this.$nextTick()
    },
    // 关闭弹出框
    handleClose() {
      this.$emit("close")
      this.familyform.sexType = ""
      this.familyform.personAge = ""
      this.familyform.birthDay = ""
      this.familyform.personStudy = "6"
      this.familyform.personPhoto = ""

      this.girduploadfilephoto = ""
      this.girduploadfile = ""
      this.$nextTick()
    },
    // 表单2-新增逐户基本信息-提交,修改
    async onSubmit1(type) {
      this.loading = true
      // this.$refs.userform.validate((valid) => {
      //     if (valid) {
      //       alert('submit!');
      //     } else {
      //       console.log('error submit!!');
      //       return false;
      //     }
      //   });
      if (type == "delete") {
        let result = await this.$http.post(
          "/admin/person/info/deletePersonById",
          {
            id: this.userform.id,
          }
        )
        this.loading = false
        this.$message(result.message)
        this.$emit("reset")
        this.handleClose()
        return false
      }
      let formData = new FormData()
      this.userform.committeeCode = this.familyform.committeeCode
      this.userform.gridCode = this.familyform.gridCode
      this.userform.streetCode = this.familyform.streetCode
      this.userform.doorCode = this.familyform.doorCode
      this.userform.familyArea = this.familyform.familyArea
      this.userform.cellNum = Number(this.familyform.cellNum)
      formData.append("sectionMapId", this.familyform.sectionMapId)
      formData.append("personVo", JSON.stringify(this.userform))
      formData.append("personFile", this.girduploadfile)
      this.familyform.familyMold = "1"
      formData.append("familyVo", JSON.stringify(this.familyform))
      let result = await this.$http.post(
        "/admin/family/info/updateFamily",
        formData
      )
      let result1 = await this.$http.post(
        "/admin/person/info/insertPerson",
        formData
      )
      // console.log(result);
      this.loading = false
      this.$message(result1.message)
      this.$emit("reset", this.familyform)
      this.handleClose()
      this.$emit("resetrenyuan")
    },
    // 表单1-家庭基本信息-修改
    //  门牌号验证
    async searchis() {
      // this.loading = true;
      // 户号书去焦点时触发事件 查询户号是否重复
      if (this.olddoorCode == this.familyform.doorCode) {
        return
      }
      let formData = new FormData()
      formData.append("familyCode", this.familyform.familyCode)
      let result = await this.$http.post(
        "/admin/family/info/findFamilyByCode",
        formData
      )
      if (result.message == "该门牌号已存在") {
        this.$alert("该门牌号已使用", "标题名称", {
          confirmButtonText: "确定",
          callback: (action) => {
            this.familyform.doorCode = this.olddoorCode
            this.$forceUpdate()
          },
        })
      }
      // this.loading = false;
      this.$message(result.message)
    },
    async resetSubmit1() {
      this.loading = true

      let formData = new FormData()
      // formData.append("familyCode", this.familyform.familyCode);
      this.familyform.familyMold = "1"
      formData.append("familyVo", JSON.stringify(this.familyform))
      let result = await this.$http.post(
        "/admin/family/info/updateFamily",
        formData
      )
      this.$message(result.message)
      this.loading = false

      this.$emit("resetrenyuan")
    },
    // ?  control  second and last form switch
    chickpage(e) {
      this.formSwitch = e
    },
    handleAvatarSuccess(res) {
      // console.log(res);
      this.userform.personPhoto = res.content
      this.$forceUpdate()
      this.$nextTick()
    },
  },
}
</script>
<style>
/* .el-form /deep/.el-form-item__label {
    color: #000;
} */
.el-form-item__label {
  color: #000 !important;
  /* width: auto !important; */
  /*min-width: 100px;*/
}
</style>

<style lang="less">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.addresident {
  .demo-form-inline {
    padding: 0 5%;
  }
  .el-dialog {
    overflow: hidden;
  }
  .el-dialog__body {
    padding: 0;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    height: 637px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 10px;
  }
  .bodymsg {
    width: 140px;
    height: 40px;
    background-color: #ffb404;
    color: #fff;
    text-align: center;
    line-height: 40px;
    border-radius: 2px;
    margin-top: 20px;
    cursor: pointer;
  }
  .switchpage {
    display: inline-block;
    margin-bottom: 10px;
  }
  .activesiwtch {
    background-color: #d6d7d8;
  }
  .el-form-item {
    text-align: right;
    margin-bottom: 11px;
    .el-input {
      width: 290px;
      border-radius: 5px;
    }
  }
  // 按钮的el-form-item 单独写样式
  .btnform {
    text-align: center;
  }
}
#file2 {
  display: none;
}

.doorphoto {
  display: inline-block;
  height: 95px;
  width: 95px;
  border: 1px dashed rgb(170, 170, 170);
  position: relative;
  border-radius: 5px;
  margin-right: 200px;
  .dooricon {
    position: absolute;
    left: 50%;
    top: 30%;
    font-size: 42px;
    color: #333;
    transform: translate(-50%, -50%);
  }
}
.uoloaddoor {
  position: absolute;
  width: 60px;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-block;
  text-align: center;
}
.uploads {
  // overflow: hidden;
  height: 95px;
  display: inline-block;
  width: 95px;
  position: relative;
  display: flex;
  border-radius: 3px;
  border: 1px solid #dedede;
  text-align: center;
  margin-right: 10px;
  .el-icon-error {
    position: absolute;
    right: -5px;
    top: -5px;
  }
}
.imgbox {
  width: 70px !important;
  height: 95px !important;
  margin: 0 auto;
  background-color: #fff;
  img {
    background-color: #fff;
    width: 70px;
    height: 95px;
    // background-image: url("https://i.postimg.cc/6pLMHDKx/71577176366-pic-hd.png");
  }
}
</style>
